import { LG, LGR, MD, SM, XL, XS, XS_M, XXL, XXS } from "constants/sizes";

export const titleFontSizes = {
  [XXS]: "12px",
  [XS_M]: "16px",
  [XS]: "24px",
  [SM]: "32px",
  [MD]: "40px",
  [LG]: "50px",
  [LGR]: "60px",
  [XL]: "72px",
  [XXL]: "80px"
};
